import { addDays, format, startOfWeek } from 'date-fns'
import type { VFC } from 'react'
import { WeekStartsOn } from '@opallabs/concepts'
import type { Theme } from '@opallabs/gem'
import * as styles from './styles'
import type { DayProps, WeekHeaderProps } from './types'

const Day: VFC<DayProps> = ({ date, theme }) => (
  <th css={styles.day({ theme })} scope="col">
    <span aria-hidden={true}>{format(date, 'EEEEE')}</span>
    <span className="sr-only">{format(date, 'EEEE')}</span>
  </th>
)
Day.displayName = 'Kuiper: Day ← WeekHeader ← DatePicker ← Inputs'

const days = (referenceDate: Date, theme: Theme) => {
  return [...(Array(7) as number[])].map((_, index) => (
    <Day date={addDays(referenceDate, index)} key={index} theme={theme} />
  ))
}

export const WeekHeader: VFC<WeekHeaderProps> = ({
  theme = 'light',
  weekStartsOn = WeekStartsOn.Sunday,
}) => {
  const referenceDate = startOfWeek(new Date(), { weekStartsOn })

  return (
    <thead css={styles.container({ theme })}>
      <tr>{days(referenceDate, theme)}</tr>
    </thead>
  )
}
WeekHeader.displayName = 'Kuiper: WeekHeader ← DatePicker ← Inputs'
